import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { useCallback } from 'react';
import { useSegmentSchedulingSelector } from '../Workflows/DisplayWebContent/state/selectors/useSegmentSchedulingSelector';

export const useStartTime = (messageId: string) => {
  const { dispatch } = useCampaignEditorContext();

  const { startTime } = useSegmentSchedulingSelector(messageId) ?? {};
  const onStartTimeChanged = useCallback(
    (startTime: string) => dispatch({ type: 'SET_SEGMENT_START_TIME', payload: { id: messageId, startTime } }),
    [dispatch, messageId],
  );

  return {
    startTime: startTime ?? '00:00',
    onStartTimeChanged,
  };
};
